import { Link, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { listResources } from '../../../../services/apis/InstallerAPIs';

const PRICE_LOCK_POLICY_NAME = 'price lock policy';

const PriceLockAcknowledgement = () => {
  // Same query as the Resources tab, so both share one cached list of active resources.
  const { data: resources } = useQuery('onePagers', listResources);

  const priceLockPolicy = resources?.find((resource) =>
    resource.resource_name.toLowerCase().includes(PRICE_LOCK_POLICY_NAME)
  );
  const downloadLink = priceLockPolicy?.download_link;

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mb: 2, textAlign: 'end' }}
    >
      By creating this loan application, you acknowledge that you have read and
      consent to Sunstone&apos;s{' '}
      {downloadLink ? (
        <Link
          href={downloadLink}
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          Price Lock Policy
        </Link>
      ) : (
        'Price Lock Policy'
      )}{' '}
      and all information in the form is complete and accurate. Please ensure
      the Net Funding amount is as you expect as change orders may slow the
      approval process.
    </Typography>
  );
};

export default PriceLockAcknowledgement;
